export default __webpack_public_path__ + "static/media/gmail.9e34ea5d.svg";